export default "__VITE_ASSET__B4TB7yDA__"